import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import * as S from '../styles';

const PriceListTableHeader: React.FC = () => {
  const { t } = useContext(AppContext);

  return (
    <thead>
      <tr>
        <S.PriceRowTableHeadExpand />
        <S.PriceRowTableHeadStore scope="col">
          <div>{t('product', 'price-list.header-store')}</div>
        </S.PriceRowTableHeadStore>
        <S.PriceRowTableHeadProduct scope="col">
          <div>{t('product', 'price-list.header-product')}</div>
        </S.PriceRowTableHeadProduct>
        <S.PriceRowTableHeadStock scope="col">
          <div>{t('product', 'price-list.header-stock')}</div>
        </S.PriceRowTableHeadStock>
        <S.PriceRowTableHeadPrice scope="col">
          <div>{t('product', 'price-list.header-price')}</div>
        </S.PriceRowTableHeadPrice>
        <S.PriceRowTableHeadClickOut />
      </tr>
    </thead>
  );
};

export default PriceListTableHeader;
